import { EmptyState, ErrorAlert, Spinner, buttonStyles } from '@lumlab/platform-ui';
import { useTranslation } from 'react-i18next';
import { Link, Outlet } from 'react-router';
import { useAccess } from '@lumlab/platform-admin/web';
import { authClient } from './auth.ts';

/** Direct product URLs obey the same access state as the navigation. The API remains authoritative. */
export function RequireProduct({ productId }: { productId: string }) {
    const { t } = useTranslation();
    const session = authClient.useSession();
    const access = useAccess(session.data?.user.id);
    if (access.isPending)
        return (
            <div className="flex items-center justify-center p-8">
                <Spinner label={t('platform.shell.loading')} />
            </div>
        );
    if (access.error) return <ErrorAlert error={access.error} />;
    if (!access.data.products.includes(productId))
        return (
            <div className="flex flex-col gap-4 items-start">
                <EmptyState
                    title={t('platform.shell.productUnavailable')}
                    description={t('platform.errors.entitlement_missing')}
                />
                <Link className={buttonStyles()} to="/">
                    {t('platform.shell.home')}
                </Link>
            </div>
        );
    return <Outlet />;
}
